// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FzcYd7Fw5d0LFu3g {
	color: var(--lok-color-text-danger);
}

.z1ADnX8KuVARp_4h {
	height: fit-content;
}
`, "",{"version":3,"sources":["webpack://./packages/rag/src/components/Cards/ProfileCard/ProfileCard.module.css"],"names":[],"mappings":"AAAA;CACC,mCAAmC;AACpC;;AAEA;CACC,mBAAmB;AACpB","sourcesContent":[".deleteMenuItem {\n\tcolor: var(--lok-color-text-danger);\n}\n\n.editMenuContainer {\n\theight: fit-content;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"deleteMenuItem": `FzcYd7Fw5d0LFu3g`,
	"editMenuContainer": `z1ADnX8KuVARp_4h`
};
export default ___CSS_LOADER_EXPORT___;
